module.exports = __webpack_public_path__ + "assets/img/btn-back-fbfc2c8e.png";